import axios from "axios";

const agencyCompanyDomains = async (token, agencyId = null) => {
  try {
    const response = await axios.get(`${window.API}/company/company-domains`, {
      params: { agencyId },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { result: response.data };
  } catch (error) {}
};

export { agencyCompanyDomains };
